import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

class TitanConfigService {
    constructor() {
        this.configInit$ = new BehaviorSubject(false);
        this.zoneInit$ = new BehaviorSubject(false);
        this._zones = [];
    }
    get environment() {
        return this._config.environment;
    }
    get features() {
        return this._config.features || {};
    }
    get app() {
        return this._config.app;
    }
    get appFeatures() {
        return (this._config.app && this._config.app.features) || {};
    }
    get ssoUrl() {
        return this._config.ssoUrl;
    }
    get username() {
        return this._config.username;
    }
    get gaiaUrlPath() {
        return this._config.gaiaUrlPath ?? '/';
    }
    get versions() {
        return this._config.versions;
    }
    get aloy() {
        return this.config.aloy;
    }
    set config(config) {
        if (this._config) {
            throw new Error('Configuration has already been initialized.');
        }
        this._config = config;
        this.configInit$.next(true);
    }
    get config() {
        return this._config;
    }
    get zones() {
        return this._zones;
    }
    set zones(zones) {
        if (this._zones.length > 0) {
            throw new Error('Zones have already been set.');
        }
        this._zones = zones;
        this.zoneInit$.next(true);
    }
    get version() {
        return this.app ? this.app.version : this.versions['gaia'];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: TitanConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: TitanConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.2", ngImport: i0, type: TitanConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TitanConfigService };
